import { ConnectionOptions, GraphApiMethod } from '@/api/core';
import {
  DeleteDispatchSummaryMarketInput,
  DeleteDispatchSummaryMarketBulkResponse,
  MutationDeleteDispatchSummaryMarketBulkArgs,
} from '@/models/gen/graphql';
import createGraphApiHook, { CreateGraphApiHookHook } from '@/hooks/createGraphApiHook';

import { TypedDocumentNode } from '@apollo/client';
import { getProperty } from '@/utils';
import graphApi from '@/api';
import { DeleteDispatchSummaryMarket } from '@/features/SummaryHistory/api/queries/DeleteDispatchSummaryMarket';

// Service Function Signature
type ServiceMethodPayload = {
  [key in keyof DeleteDispatchSummaryMarketInput]?: any;
}[];
interface ServiceMethod {
  (payload?: ServiceMethodPayload, options?: ConnectionOptions): Promise<DeleteDispatchSummaryMarketBulkResponse>;
}

// DeleteDispatchSummaryMarket Service
export const { deleteDispatchSummaryMarket, useDeleteDispatchSummaryMarket } = ((): {
  deleteDispatchSummaryMarket: ServiceMethod;
  useDeleteDispatchSummaryMarket: CreateGraphApiHookHook<ServiceMethod>;
} => {
  const [fetch] = graphApi(DeleteDispatchSummaryMarket).map(
    (fn: GraphApiMethod<TypedDocumentNode>): ServiceMethod =>
      async (
        payload?: DeleteDispatchSummaryMarketInput[],
        options?: ConnectionOptions
      ): Promise<DeleteDispatchSummaryMarketBulkResponse> => {
        const args: MutationDeleteDispatchSummaryMarketBulkArgs = {
          input: {
            search: payload,
          },
        };
        const opts = { merge: options?.merge ? 'deleteDispatchSummaryMarketBulk' : undefined };
        const res = await fn(args, opts);
        return getProperty('deleteDispatchSummaryMarketBulk', res);
      }
  );
  const useService = createGraphApiHook(fetch);
  return {
    deleteDispatchSummaryMarket: fetch,
    useDeleteDispatchSummaryMarket: useService,
  };
})();
